import React from "react";
import { Alert, Typography, Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { useDrawer } from "../Drawer";
import JSONPretty from 'react-json-pretty';
import { Icon } from "src/mtska-frontend-app-component/assets";
import { Button } from "../Button";
import { useDataProvider } from "src/mtska-frontend-data-provider";

const VehicleInstalledAnalysis = ({ car_id, analysis }) => {
    const {activate} = useDrawer();
    const { loadOne } = useDataProvider('cars/car');

    const handleAction = (id) => {
        activate('rentersinstalled/detail', { id: analysis.sychronizable_id, similar_id: car_id, afterSave:() => loadOne(car_id) })
    }

    return (
        <Box className="mtska-vehicle-installed-analysis">
            <Alert
                color="danger"
                variant="soft"
                startDecorator={<Icon icon="faWarning" />}
                endDecorator={
                    <Button
                        size="sm"
                        variant="solid"
                        color="danger"
                        onClick={() => handleAction(analysis.sychronizable_id)}
                    >
                        Resolve
                    </Button>
                }
            >
                <Typography level="body-sm">
                    <strong>{analysis.action}</strong> · {analysis.processStatus} · {analysis.engine} · Score: {analysis.scores.total.toFixed(2)}
                </Typography>
            </Alert>
        </Box>
    )
}

export default VehicleInstalledAnalysis
